import Icon from '../components/Icon.vue'

Icon.register({"concierge-bell":{"width":512,"height":512,"paths":[{"d":"M288 130.5V112H304C312.8 112 320 104.8 320 96V80C320 71.2 312.8 64 304 64H208C199.2 64 192 71.2 192 80V96C192 104.8 199.2 112 208 112H224V130.5C115.5 146.1 32 239.2 32 352H480C480 239.2 396.5 146.1 288 130.5zM496 384H16C7.2 384 0 391.2 0 400V432C0 440.8 7.2 448 16 448H496C504.8 448 512 440.8 512 432V400C512 391.2 504.8 384 496 384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/concierge-bell.js
// module id = null
// module chunks = 